import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import lasVegas__asset from "@/assets/restore/locations/las-vegas.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Las Vegas",
    address: "871 Coronado Center Drive, Suite 200, Henderson",
    img: lasVegas__asset.url,
    mapUrl: map("871 Coronado Center Drive Henderson NV"),
    to: "/locations/nevada/las-vegas/",
  },
];

export const Route = createFileRoute("/locations/nevada/")({
  head: () => ({
    meta: [
      { title: "Nevada Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Nevada. Book a free personal hair loss consultation at our Las Vegas / Henderson location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Nevada Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Las Vegas, Nevada and book a free consultation to learn about the FUE procedure.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/nevada/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/nevada/" }],
  }),
  component: () => <StateLocationsHub stateName="Nevada" cities={cities} />,
});